import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import {
  deleteConversation,
  renameConversation,
  toggleFavorite,
} from "../api/mutateConversation";

/**
 * Conversation list mutations (rename / delete / favorite). Each invalidates the
 * whole conversations namespace so the sidebar list and any open thread re-sync
 * from the server — the single owner of conversation state.
 */
export function useRenameConversation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, title }: { id: string; title: string }) => renameConversation(id, title),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.conversations.all }),
  });
}

export function useDeleteConversation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteConversation(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.conversations.all }),
  });
}

export function useToggleFavorite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => toggleFavorite(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.conversations.all }),
  });
}
